import React from 'react';

export default class  Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="innovativeimg">
                                                    <img alt=""
                                                         src={require('@images/How to raise energy levels.png')}/>
                                                </div>

                                                <div className="ilead-contentarea">
                                                    <div className="circle_title "><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>isn't it interesting?</div>
                                                    <div className="border_subtitle">Half empty or half full?</div>
                                                    <p>Looking at a glass and determining whether it is half full or
                                                        half empty seems to be the long-standing benchmark for
                                                        determining whether someone is an optimist or pessimist.</p>
                                                    <p>This tool is about raising your energy levels and being able to
                                                        transfer this energy to the people you work with. Having a
                                                        positive outlook (seeing the glass half full) is an important
                                                        part of this because, as the study below shows, optimism can be
                                                        a key factor in energy levels at work. For more information on
                                                        optimism see the iLEAD<sup>™</sup> tool ‘How to use optimism to
                                                        achieve’.</p>

                                                    <div className="lightgreencontentbg keyquestionpad">
                                                        <div className="border_subtitle">Why optimism matters</div>
                                                        <p>A study by Manju Puri &amp; David Robinson<a
                                                            className="superscripttext"
                                                            href="further_info.php?page=1&amp;course=300"><sup>1</sup></a> looked
                                                            into the effects of optimism on behaviour in and out of the
                                                            workplace. Participants were assessed for optimistic traits
                                                            using psychometric measures and the pre-existing Survey of
                                                            Consumer Finance. From this data 3 groups were formed:
                                                            ‘non-optimists’, ‘moderate-optimists’ &amp; ‘extreme
                                                            optimists’.</p>
                                                        <p>It was found that there was a higher incidence of behaviour
                                                            differences in the optimists vs. non-optimists. Optimists
                                                            are more likely to work harder, expect to retire later, save
                                                            more and invest in the stock market. The first of these
                                                            effects is obviously of most interest to this tool, but the
                                                            others highlight the wide-ranging impact optimism can
                                                            have.</p>
                                                        <p>Furthermore, these various effects indicate increased
                                                            engagement, at work and outside work, and this can help with
                                                            raising your energy levels.</p>
                                                    </div>
                                                    <div className="border_subtitle">This tool can help</div>
                                                    <p>There are many situations (whether at work or at home) where that
                                                        extra bit of energy would be useful. This tool is about <span
                                                            className="brown brownbold">how to raise your own energy levels and transmit energy to others.</span>

                                                        It will help you to explore the link between motivation and
                                                        energy levels and explain how to energise others more
                                                        effectively through positive thinking.</p>

                                                    <div className="right-btn"><div
                                                        onClick={this.props.handleChangePage('Page2')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div></div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}